import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePlayerContext } from '../Context';
import { TextTrackEvents } from '../../sdk/PlayerEvents';
import { Events, State, AudioTrack, TextTrack } from '../../types/player';
import ControlMenu from '../ui/ControlMenu';
import SelectControl, { Item } from '../ui/SelectControl';

const TextTracksSelector = () => {
  const { sdk } = usePlayerContext();
  const { t } = useTranslation();

  const [textTracks, setTextTracks] = useState(sdk.getTextTracks());

  const slug = 'TextTrack';
  let index: number = -1;
  if (sdk.hasTextTracks()) {
    index = typeof sdk.getCurrentTextTrack()?.index == 'number' ? sdk.getCurrentTextTrack()?.index as number : -1;
  }
  const [currentTextTrackIndex, setCurrentTextTrackIndex] = useState(index);

  useEffect(() => {
    sdk.on(Events.TEXTTRACK_CHANGED, (textTrack: TextTrackEvents) => {
      setCurrentTextTrackIndex(textTrack.index);
    });
  }, []);

  function setCurrentTextTrack(index: number) {
    sdk.setCurrentTextTrack(index);
    sdk.toggleControlMenu(slug);
  }

  function getTextTrackLabel(TextTrack: TextTrack) {
    let hook = sdk.options().getLocale()?.hooks?.textTrackLabel;
    if (hook) {
      const customLabel = hook(TextTrack);
      if (customLabel) return customLabel;
    }
    return `${TextTrack.label} (${TextTrack.kind})`;
  }

  const setCurrent = (TextTrack: string) => {
    setCurrentTextTrack(parseInt(TextTrack) as number);
  };

  const items: Item[] = [{ val: -1, label: t('No TextTrack') }];
  textTracks.map((textTrack, index) => {
    items.push({ val: index as number, label: getTextTrackLabel(textTrack) });
  });

  const selector = (
    <div
      className={`${sdk.getClassNamePrefix()}-player-control-menu-list ${sdk.getClassNamePrefix()}-player-control-menu-list-${slug}`}
    >
      <SelectControl
        items={items}
        currentValue={currentTextTrackIndex}
        controlSlug={slug}
        handleAction={setCurrent}
      />
    </div>
  );

  if (!sdk.hasTextTracks()) {
    return null;
  }

  return (
    <ControlMenu
      icon={'closedCaptioning'}
      controlClassName={'TextTrack'}
      title={'Sub title'}
      content={selector}
    />
  );
};

export default TextTracksSelector;
